import React from 'react'

const PerformanceLink = ({videoURL}) => {
  return (
    <div className="gpt3-videorecognition gpt3-videoperformances-card">
    <div className="gpt3-videorecognition-content gpt3-videoperformances-card-content">
        <a href="#portfolioModal1" className="portfolio-link" data-toggle="modal">
            <iframe className="gpt3-videoperformances-frame" src={videoURL} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </a>
    </div>
</div>
  )
}

export default PerformanceLink
